import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
const Products = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('starter');

    const models = {
        starter: {
            name: "Starter Edition",
            price: "Comming soon!!",
            description: "Perfect for small businesses and entrepreneurs just getting started.",
            features: [
                "Basic inventory tracking (up to 500 items)",
                "Simple sales processing",
                "Standard expense categories",
                "Basic payment processing",
                "Cloud backup"
            ],
            cta: "Best for new businesses"
        },
        professional: {
            name: "Professional Edition",
            price: "Comming soon!!",
            description: "Designed for growing businesses with moderate inventory and sales volume.",
            features: [
                "Advanced inventory management (up to 5,000 items)",
                "Multi-user sales processing",
                "Custom expense categories and reporting",
                "Multiple payment gateway integration",
                "API access for basic integrations"
            ],
            cta: "Most popular choice"
        },
        enterprise: {
            name: "Enterprise Solution",
            price: "Comming soon!!",
            description: "Our most powerful option, built for large-scale operations with complex needs.",
            features: [
                "Unlimited inventory capacity with multi-location support",
                "Advanced sales analytics and forecasting",
                "Custom financial reporting and dashboards",
                "Enterprise-grade payment security",
                "Full API access and custom integrations"
            ],
            cta: "For established businesses"
        }
    };

    return (
        <div className="bg-white min-h-screen">
            {/* Hero Section */}
            <div className="bg-primary mt-[90px] text-white text-center py-16">
                <div className="container mx-auto px-4">
                    <h1 className="text-4xl font-bold mb-4">Smart Business Calculator</h1>
                    <p className="text-xl mb-8">The All-in-One Solution for Your Business Operations</p>
                    <button className="bg-white text-secondary px-6 py-3 rounded-full font-bold hover:bg-gray-100 transition duration-300" onClick={() => navigate('/become-merchant')}>
                        Get Started Today
                    </button>
                </div>
            </div>

            {/* Models Section */}
            <div className="bg-gray-50 py-16">
                <div className="container mx-auto px-4">
                    <h2 className="text-3xl font-bold text-center text-primary mb-12">Available Models</h2>

                    {/* Tabs */}
                    <div className="flex justify-center mb-8">
                        <div className="inline-flex rounded-lg border border-gray-200 p-1 bg-white">
                            {Object.keys(models).map((model) => (
                                <button
                                    key={model}
                                    className={`px-4 py-2 rounded-md ${activeTab === model
                                            ? 'bg-secondary text-white'
                                            : 'text-gray-700 hover:bg-gray-100'
                                        } transition duration-300`}
                                    onClick={() => setActiveTab(model)}
                                >
                                    {models[model].name}
                                </button>
                            ))}
                        </div>
                    </div>

                    {/* Active model details */}
                    <div className="bg-white rounded-xl shadow-lg p-8 max-w-3xl mx-auto border-t-4 border-secondary">
                        <div className="flex justify-between items-start mb-6">
                            <div>
                                <h3 className="text-2xl font-bold text-gray-800">{models[activeTab].name}</h3>
                                <p className="text-gray-600 mt-1">{models[activeTab].description}</p>
                            </div>
                            <div className="text-right">
                                <div className="text-3xl font-bold text-secondary">{models[activeTab].price}</div>
                                <span className="text-sm text-gray-500">billed monthly</span>
                            </div>
                        </div>

                        <div className="mb-8">
                            <h4 className="font-semibold mb-3 text-gray-700">Includes:</h4>
                            <ul className="space-y-3">
                                {models[activeTab].features.map((feature, index) => (
                                    <li key={index} className="flex items-start">
                                        <span className="text-green-500 mr-2">✓</span>
                                        <span>{feature}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <button className="w-full bg-secondary text-white py-3 rounded-lg font-bold hover:bg-indigo-700 transition duration-300">
                            Select {models[activeTab].name}
                        </button>
                        <div className="text-center mt-3 text-sm text-secondary font-medium">
                            {models[activeTab].cta}
                        </div>
                    </div>
                </div>
            </div>
            {/* CTA Section */}
            <div className="bg-primary text-white py-16">
                <div className="container mx-auto px-4 text-center">
                    <h2 className="text-3xl font-bold mb-4">Ready to transform your business operations?</h2>
                    <p className="text-xl mb-8 max-w-2xl mx-auto">
                        Join thousands of businesses that have streamlined their operations with our smart calculator solution.
                    </p>
                    <div className="flex justify-center gap-4 flex-wrap">
                        <button className="bg-white text-secondary px-6 py-3 rounded-full font-bold transition duration-300">
                            Contact Sales
                        </button>
                        <button className="bg-transparent text-white border-2 border-white px-6 py-3 rounded-full font-bold hover:text-primary transition duration-300">
                            Schedule Demo
                        </button>
                    </div>
                </div>
            </div>

            {/* Support Section */}
            <div className="container mx-auto py-16 px-4">
                <h2 className="text-3xl font-bold text-center mb-12">Customer Support</h2>
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-4xl mx-auto">
                    <div className="text-center">
                        <div className="bg-indigo-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                            <span className="text-indigo-600 text-2xl">🚀</span>
                        </div>
                        <h3 className="font-bold mb-2">Free Setup</h3>
                        <p className="text-gray-600">Get started quickly with our guided setup process</p>
                    </div>
                    <div className="text-center">
                        <div className="bg-indigo-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                            <span className="text-indigo-600 text-2xl">🔧</span>
                        </div>
                        <h3 className="font-bold mb-2">24/7 Support</h3>
                        <p className="text-gray-600">Technical assistance whenever you need it</p>
                    </div>
                    <div className="text-center">
                        <div className="bg-indigo-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                            <span className="text-indigo-600 text-2xl">📚</span>
                        </div>
                        <h3 className="font-bold mb-2">Learning Resources</h3>
                        <p className="text-gray-600">Comprehensive guides and video tutorials</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Products;